import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";
import axios from "axios";
import { getapiKey, getbaseURL } from "../../api/axios";
const API_URL = "https://api.ozilcrm.com/api";
const getAuthHeaders = () => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  if (!user?.token) {
    throw new Error("Authentication token is missing or invalid");
  }
  return {
    Authorization: `Bearer ${user.token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  };
};

const getAuthHeadersapiKey = () => {
  return {
    Authorization: `Bearer ${getapiKey()}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  };
};
export const fetchFlights = createAsyncThunk("flights/fetchFlights", async (searchParams, { rejectWithValue }) => {
  try {
    const response = await api.post(`/flight/v3/searchquery`, searchParams, {
      headers: getAuthHeaders(),
    });

    return {
      data: response.data,
      interNationalSearch: searchParams.interNationalSearch,
      routeType: searchParams.JourneyType,
    };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to fetch flights",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});
export const SearchqueryReissue = createAsyncThunk(
  "flights/SearchqueryReissue",
  async (searchParams, { rejectWithValue }) => {
    console.log(searchParams);

    try {
      const response = await api.post(`/flight/v3/reissue/searchquery`, searchParams, {
        headers: getAuthHeaders(),
      });

      return {
        data: response.data,
        interNationalSearch: searchParams.interNationalSearch,
        routeType: searchParams.JourneyType,
      };
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to fetch flights",
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const fetchFlightResults = createAsyncThunk(
  "flights/fetchFlightResults",
  async ({ searchId, currency }, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `/flight/v2/search-result`,
        { searchId, currency },
        {
          headers: getAuthHeaders(),
        }
      );
      return { searchId, data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to fetch flight results",
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
export const fetchgroupfare = createAsyncThunk("flights/fetchgroupfare", async (payload, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${getbaseURL()}/flight/v3/available-sector`, payload, {
      headers: getAuthHeadersapiKey(),
    });

    return response.data;
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to fetch flight results",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});

export const fetchFlightResultsNew = createAsyncThunk(
  "flights/fetchFlightResultsNew",
  async ({ searchId, currency, index, searchIDS, reissue }, { rejectWithValue }) => {
    try {
      let URL = "";
      if (reissue) {
        URL = `/flight/v3/reissue/search-result`;
      } else {
        URL = `/flight/v3/search-result`;
      }
      const response = await api.post(
        URL,
        { searchId, currency },
        {
          headers: getAuthHeaders(),
        }
      );
      return { searchId, index, searchIDS, data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to fetch flight results",
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const fetchFareRules = createAsyncThunk(
  "flights/fetchFareRules",
  async ({ priceId, searchId, currency }, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `/flight/v3/farerules`,
        {
          priceid: priceId,
          TraceId: null,
          searchId,
          currency,
        },
        {
          headers: getAuthHeaders(),
        }
      );
      return { data: response.data, priceId };
    } catch (error) {
      return rejectWithValue({
        priceId,
        message: error.message,
        error: error.response?.data,
      });
    }
  }
);

// ✅ New thunk: validate fare before booking
export const fetchValidateFare = createAsyncThunk("flights/validateFare", async ({ FormData }, { rejectWithValue }) => {
  try {
    // API call to validate fare
    let url = "";
    if (FormData?.reissue) {
      url = "flight/v3/reissue/validatefare";
    } else {
      url = "/flight/v3/validatefare";
    }
    const response = await api.post(url, FormData, { headers: getAuthHeaders() });

    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to validate fare",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});
export const fetchSeatMap = createAsyncThunk("flights/seatmapapi", async ({ RequestData }, { rejectWithValue }) => {
  try {
    // API call to validate fare
    const response = await api.post(`/flight/v3/seatmapapi`, RequestData, { headers: getAuthHeaders() });

    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to validate fare",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});
export const fetchMemberList = createAsyncThunk("flights/get-member-list", async ({ RequestData }, { rejectWithValue }) => {
  try {
    // API call to validate fare
    const response = await api.post(`/manage-user/get-member-list`, RequestData, { headers: getAuthHeaders() });

    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to validate fare",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});
export const SavePassenger = createAsyncThunk(
  "flights/saveitinerary",
  async ({ SaveItinirary }, { rejectWithValue }) => {
    try {
      // API call to validate fare
      const response = await api.post(`/flight/v3/saveitinerary`, SaveItinirary, { headers: getAuthHeaders() });

      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to validate fare",
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const UpdatePassengers = createAsyncThunk(
  "flights/updatepassenger",
  async ({ SaveItinirary }, { rejectWithValue }) => {
    try {
      // API call to validate fare
      const response = await api.post(`/flight/v3/updatepassenger`, SaveItinirary, { headers: getAuthHeaders() });

      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to validate fare",
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const fetchBookingDetails = createAsyncThunk(
  "flights/bookingdetails",
  async ({ BookingID }, { rejectWithValue }) => {
    try {
      // API call to validate fare
      const response = await api.post(
        `/flight/v3/bookingdetails`,
        { BookingID: BookingID },
        { headers: getAuthHeaders() }
      );

      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to validate fare",
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const fetchPassengerDetails = createAsyncThunk(
  "flights/offlinecost",
  async ({ BookingID, IsApiBooking }, { rejectWithValue }) => {
    try {
      // API call to validate fare
      const response = await api.post(
        `/flight/v3/offlinecost/${BookingID}`,
        { BookingID: BookingID, IsApiBooking: IsApiBooking },
        { headers: getAuthHeaders() }
      );

      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to validate fare",
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
export const sendconfirmation = createAsyncThunk(
  "sms/confirmation",
  async ({ confirmed }, { rejectWithValue }) => {
    try {
      // API call to validate fare
      const response = await api.post(
        `/sms/confirmation`,
        { BookingID: confirmed.BookingID, PlanType: confirmed.PlanType },
        { headers: getAuthHeaders() }
      );

      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to validate fare",
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
export const doBookingProcess = createAsyncThunk(
  "flights/bookingprocess",
  async ({ bookingProcess }, { rejectWithValue }) => {
    try {
      // API call to validate fare
      const response = await api.post(`/flight/v3/bookingprocess`, bookingProcess, { headers: getAuthHeaders() });
      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to validate fare",
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
export const DoUpdatediscountMarkup = createAsyncThunk(
  "flights/updatediscountmarkup",
  async ({ formData }, { rejectWithValue }) => {
    try {
      // API call to validate fare
      const response = await api.post(`/flight/v3/updatediscountmarkup`, formData, { headers: getAuthHeaders() });
      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to validate fare",
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
export const DoSendticket = createAsyncThunk("flights/sendticket", async ({ formData }, { rejectWithValue }) => {
  try {
    // API call to validate fare
    const response = await api.post(`/flight/v3/sendticket`, formData, { headers: getAuthHeaders() });
    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to validate fare",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});
export const fetchbookingcalendar = createAsyncThunk(
  "flights/bookingcalendar",
  async ({ FilterData, perPage, cursor = null }, { rejectWithValue }) => {
    try {
      let url = `/flight/v3/bookingcalendar?per_page=${perPage}`;
      if (cursor) {
        url += `&cursor=${encodeURIComponent(cursor)}`;
      }
      // API call to validate fare
      const response = await api.post(url, FilterData, { headers: getAuthHeaders() });
      return { data: response.data };
    } catch (error) {
      // if (error.response.data.httpStatus === 401 && error.response.data.message === 'Unauthenticated') {
      //   localStorage.removeItem('user');
      //   window.location.reload();
      // }
      return rejectWithValue({
        message: error?.response?.message || "Failed to validate fare",
        status: error.response?.data?.status,
        data: error.response?.data,
      });
    }
  }
);
export const fetchGroupRequest = createAsyncThunk(
  "flights/bookingcalendar",
  async ({ FilterData, perPage, cursor = null }, { rejectWithValue }) => {
    try {
      let url = `/flight/v3/grouprequestlist?per_page=${perPage}`;
      if (cursor) {
        url += `&cursor=${encodeURIComponent(cursor)}`;
      }
      // API call to validate fare
      const response = await api.post(url, FilterData, { headers: getAuthHeaders() });
      return { data: response.data };
    } catch (error) {
      // if (error.response.data.httpStatus === 401 && error.response.data.message === 'Unauthenticated') {
      //   localStorage.removeItem('user');
      //   window.location.reload();
      // }
      return rejectWithValue({
        message: error?.response?.message || "Failed to validate fare",
        status: error.response?.data?.status,
        data: error.response?.data,
      });
    }
  }
);
export const fetchbnplduereport = createAsyncThunk(
  "flights/bnplduereport",
  async ({ FilterData, perPage, currentPage }, { rejectWithValue }) => {
    try {
      let url = `/flight/v3/bnplduereport?per_page=${perPage}&page=${currentPage}`;
      // API call to validate fare
      const response = await api.post(url, FilterData, { headers: getAuthHeaders() });
      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to validate fare",
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const GETAmendmentCharges = createAsyncThunk(
  "flights/amendment-charges",
  async ({ postData }, { rejectWithValue }) => {
    try {
      // API call to validate fare
      const response = await api.post(`/flight/v3/amendment-charges`, postData, { headers: getAuthHeaders() });
      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to validate fare",
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
export const SubmitAmendmentCharges = createAsyncThunk(
  "flights/amendment-submit",
  async ({ formData }, { rejectWithValue }) => {
    try {
      // API call to validate fare
      const response = await api.post(`/flight/v3/amendment-submit`, formData,
        {
          headers: {
            ...getAuthHeaders(),
            "Content-Type": "multipart/form-data", // Important for file upload
          }
        }

      );
      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to validate fare",
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
export const DoTicketUnhold = createAsyncThunk("flights/unhold", async ({ formDataHold }, { rejectWithValue }) => {
  try {
    // API call to validate fare
    const response = await api.post(`/flight/v3/unhold`, formDataHold, { headers: getAuthHeaders() });
    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to validate fare",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});
export const validatecoupons = createAsyncThunk("flights/marketing", async ({ postData }, { rejectWithValue }) => {
  try {
    // API call to validate fare
    const response = await api.post(`/marketing/coupons/validate`, postData, { headers: getAuthHeaders() });
    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to validate fare",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});
export const getcouponlist = createAsyncThunk("flights/marketing", async ({ postData }, { rejectWithValue }) => {
  try {
    // API call to validate fare
    const response = await api.post(`/marketing/getapicouponlist`, postData, { headers: getAuthHeaders() });
    return { data: response.data };
  } catch (error) {
    return rejectWithValue({
      message: error.message || "Failed to validate fare",
      status: error.response?.status,
      data: error.response?.data,
    });
  }
});

export const SaveGroupRequest = createAsyncThunk(
  "flights/grouprequest",
  async ({ payload }, { rejectWithValue }) => {
    try {
      // API call to validate fare
      const response = await api.post(`/flight/v3/grouprequest`, payload, { headers: getAuthHeaders() });

      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to validate fare",
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
export const ShareFlightProposal = createAsyncThunk(
  "flights/shareflight",
  async ({ payload }, { rejectWithValue }) => {
    try {
      // API call to validate fare
      const response = await api.post(`/flight/v3/shareflight`, payload, { headers: getAuthHeaders() });

      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to validate fare",
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const offlineTicketQueue = createAsyncThunk(
  "flights/offline-ticket-queue",
  async ({ payload }, { rejectWithValue }) => {
    try {
      // API call to validate fare
      const response = await api.post(`/flight/v3/offline-ticket-queue`, payload, { headers: getAuthHeaders() });

      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to validate fare",
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const GroupRequestUpdate = createAsyncThunk(
  "flights/GroupRequestUpdate",
  async ({ postData }, { rejectWithValue }) => {
    try {
      // API call to validate fare
      const response = await api.post(`/flight/v3/group-request-update`, postData, { headers: getAuthHeaders() });

      return { data: response.data };
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to validate fare",
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);


const initialState = {
  data: null,
  resultsById: {},
  status: "idle",
  resultStatus: {},
  interNationalSearch: "0",
  routeType: "1",
  flights: {
    outbound: [],
    inbound: [],
    roundTrip: [], // Added for international round-trip
  },
  filters: {
    airline: [],
    stops: [],
    price: { Minpr: 0, Maxpr: 100000 },
    departureTime: [],
  },
  selectedFilters: {
    airline: [],
    stops: [],
    priceRange: [0, 100000],
    departureTime: [],
  },
  fareRules: {},
  fareRulesStatus: {},
  error: null,
  fareValidation: {}, // ✅ store validation response by searchId
  fareValidationStatus: "idle",
  saveitineraryData: {}, // ✅ store validation response by searchId
  saveitineraryStatus: "idle",
  offlineQueueData: {}, // ✅ store validation response by searchId
  offlineQueueStatus: "idle",
  UpdatePassData: {}, // ✅ store validation response by searchId
  UpdatePasseStatus: "idle",
  RequestData: {}, // ✅ store validation response by searchId
  RequestStatus: "idle",
  BookingDetails: {}, // ✅ store validation response by searchId
  BookingDetailsStatus: "idle",
  PassengerDetails: {}, // ✅ store validation response by searchId
  PassengerDetailsStatus: "idle",
  BookingProcess: {}, // ✅ store validation response by searchId
  BookingProcessStatus: "idle",
  bookingcalendar: {}, // ✅ store validation response by searchId
  bookingcalendarStatus: "idle",
  bnpldue: {}, // ✅ store validation response by searchId
  bnpldueStatus: "idle",
  validatecoup: {}, // ✅ store validation response by searchId
  validatecoupStatus: "idle",
  SearchResponse: {}, // ✅ store validation response by searchId
  SearchResponseStatus: "idle",
  Searchindex: 0,
  SearchsearchIDS: [],
  GroupFareStatus: "idle",
  GroupFareData: {},
  saveGroupReqData: {}, // ✅ store validation response by searchId
  saveGroupReqStatus: "idle",
};

const timeRangeLabels = {
  "00:00-08:00": "Midnight - 8 am",
  "08:00-12:00": "8 am - Noon",
  "12:00-16:00": "Noon - 4 pm",
  "16:00-20:00": "4 pm - 8 pm",
  "20:00-23:59": "8 pm - Midnight",
};

// Memoized function to generate departure time ranges
const generateDepartureTimeRanges = (flights) => {
  const timeRanges = new Set();
  flights.forEach((flight) => {
    if (flight.FilDetime && timeRangeLabels[flight.FilDetime]) {
      timeRanges.add(flight.FilDetime);
    }
    // Include des.FilDetime for round-trip flights
    if (flight.des?.FilDetime && timeRangeLabels[flight.des.FilDetime]) {
      timeRanges.add(flight.des.FilDetime);
    }
  });
  return Array.from(timeRanges).map((range) => ({
    label: timeRangeLabels[range],
    range: range.split("-").map((time) => parseInt(time.split(":")[0], 10)),
  }));
};

const flightsSlice = createSlice({
  name: "flights",
  initialState,
  reducers: {
    resetFareValidation: (state) => {
      state.fareValidation = null;
      state.fareValidationStatus = "idle";
      state.error = null;
    },
    resetSaveItinerary: (state) => {
      state.saveitineraryData = null;
      state.saveitineraryStatus = "idle";
      state.error = null;
    },
    resetBookingDetails: (state) => {
      state.BookingDetails = null;
      state.BookingDetailsStatus = "idle";
      state.error = null;
    },
    resetFlightData(state) {
      state.SearchResponseStatus = "idle";
      state.data = null;
      state.SearchResponse = {};
      state.resultsById = {};
      state.status = "idle";
      state.resultStatus = {};
      state.interNationalSearch = "0";
      state.routeType = "1";
      state.Searchindex = 0;
      state.flights.outbound = [];
      state.flights.inbound = [];
      state.flights.roundTrip = []; // Reset roundTrip
      state.error = null;
      state.selectedFilters = {
        ...state.selectedFilters,
        priceRange: [state.filters.price.Minpr, state.filters.price.Maxpr],
      };
    },
    setFlightsAndFilters: (state, action) => {
      const resultSets = Array.isArray(action.payload) ? action.payload : [action.payload];
      let outboundFlights = [...state.flights.outbound];
      let inboundFlights = [...state.flights.inbound];
      let roundTripFlights = [...state.flights.roundTrip];
      let filtAirlineName = [];
      let filtStop = [];
      let filtPrice = [];

      resultSets.forEach((searchId) => {
        const data = state.resultsById[searchId]?.resultSet || {};
        const tempOutbound = Array.isArray(data.outbound) ? data.outbound : [];
        const tempInbound = Array.isArray(data.inbound) ? data.inbound : [];

        if (state.interNationalSearch === "1" && state.routeType === "2") {
          // Handle international round-trip: store in roundTripFlights
          roundTripFlights = [...roundTripFlights, ...tempOutbound];
          filtAirlineName = [
            ...filtAirlineName,
            ...(Array.isArray(data.FiltAirlineName?.[0]) ? data.FiltAirlineName[0] : []),
          ];
          filtStop = [...filtStop, ...(Array.isArray(data.FiltStop?.[0]) ? data.FiltStop[0] : [])];
          if (data.FiltPrice?.[0]) {
            filtPrice = [...filtPrice, data.FiltPrice[0]];
          }
        } else {
          // Existing logic for one-way and domestic round-trip
          outboundFlights = [...outboundFlights, ...tempOutbound];
          inboundFlights = [...inboundFlights, ...tempInbound];
          filtAirlineName = [
            ...filtAirlineName,
            ...(Array.isArray(data.FiltAirlineName?.[0]) ? data.FiltAirlineName[0] : []),
          ];
          filtStop = [...filtStop, ...(Array.isArray(data.FiltStop?.[0]) ? data.FiltStop[0] : [])];
          if (data.FiltPrice?.[0]) {
            filtPrice = [...filtPrice, data.FiltPrice[0]];
          }
        }
      });

      state.flights.outbound = outboundFlights;
      state.flights.inbound = inboundFlights;
      state.flights.roundTrip = roundTripFlights;

      state.filters.airline = [
        ...new Set(
          filtAirlineName.map((code) => {
            const [, name] = code.split("-") || [code, code];
            return name || code;
          })
        ),
      ];

      state.filters.stops = [...new Set(filtStop.map((stop) => String(stop).replace(" Stop", "").replace("(s)", "")))];

      state.filters.price =
        filtPrice.length > 0
          ? {
            Minpr: Math.min(...filtPrice.map((p) => p.Minpr || 0)),
            Maxpr: Math.max(...filtPrice.map((p) => p.Maxpr || 100000)),
          }
          : { Minpr: 0, Maxpr: 100000 };

      // Generate departure time ranges from all flight types
      state.filters.departureTime = generateDepartureTimeRanges([
        ...outboundFlights,
        ...inboundFlights,
        ...roundTripFlights,
      ]);

      state.selectedFilters.priceRange = [state.filters.price.Minpr, state.filters.price.Maxpr];
    },
    setFlightsAndFiltersNew: (state, action) => {
      const data = action.payload ? action.payload : action.payload;
      let outboundFlights = [...state.flights.outbound];
      let inboundFlights = [...state.flights.inbound];

      const outbound_ = data?.resultSet?.outbound || [];
      const inbound_ = data?.resultSet?.inbound || [];

      outboundFlights = [...outboundFlights, ...outbound_];
      inboundFlights = [...inboundFlights, ...inbound_];

      // console.log(state.interNationalSearch);
      // console.log(state.routeType);
      if (outboundFlights.length === 0 && state.Searchindex + 1 !== state.SearchsearchIDS.length) {
        state.SearchResponseStatus = "loading";
      } else if (outboundFlights.length > 0) {
        state.SearchResponseStatus = true;
      } else if (state.Searchindex + 1 === state.SearchsearchIDS.length && outboundFlights.length === 0) {
        state.SearchResponseStatus = true;
      }
      console.log(state.Searchindex + 1);
      console.log(state.SearchsearchIDS.length);
      state.flights.outbound = outboundFlights;
      state.flights.inbound = inboundFlights;
    },
    updateAirlineFilter: (state, action) => {
      const value = action.payload;
      state.selectedFilters.airline = state.selectedFilters.airline.includes(value)
        ? state.selectedFilters.airline.filter((a) => a !== value)
        : [...state.selectedFilters.airline, value];
    },
    updateStopFilter: (state, action) => {
      const value = String(action.payload).replace(" Stop", "").replace("(s)", "");
      state.selectedFilters.stops = state.selectedFilters.stops.includes(value)
        ? state.selectedFilters.stops.filter((s) => s !== value)
        : [...state.selectedFilters.stops, value];
    },
    updatePriceRange: (state, action) => {
      const [min, max] = action.payload;
      state.selectedFilters.priceRange = [
        Math.max(state.filters.price.Minpr, min),
        Math.min(state.filters.price.Maxpr, max),
      ];
    },
    updateDepartureTimeFilter: (state, action) => {
      const value = action.payload;
      state.selectedFilters.departureTime = state.selectedFilters.departureTime.includes(value)
        ? state.selectedFilters.departureTime.filter((t) => t !== value)
        : [...state.selectedFilters.departureTime, value];
    },
    clearAllFilters: (state) => {
      state.selectedFilters = {
        airline: [],
        stops: [],
        priceRange: [state.filters.price.Minpr, state.filters.price.Maxpr],
        departureTime: [],
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFlights.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchFlights.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = {
          ...action.payload.data,
          searchQuery: action.meta.arg.APIData.searchQuery,
        };
        state.interNationalSearch = action.payload.interNationalSearch;
        state.routeType = action.payload.routeType;
        state.error = null;
      })
      .addCase(fetchFlights.rejected, (state, action) => {
        state.status = "failed";
        state.error = JSON.stringify(action.payload);
      })
      .addCase(SearchqueryReissue.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(SearchqueryReissue.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = {
          ...action.payload.data,
          searchQuery: action.meta.arg.APIData.searchQuery,
        };
        state.interNationalSearch = action.payload.interNationalSearch;
        state.routeType = action.payload.routeType;
        state.error = null;
      })
      .addCase(SearchqueryReissue.rejected, (state, action) => {
        state.status = "failed";
        state.error = JSON.stringify(action.payload);
      })
      .addCase(fetchFlightResults.pending, (state, action) => {
        state.resultStatus[action.meta.arg.searchId] = "loading";
        state.error = null;
      })
      .addCase(fetchFlightResults.fulfilled, (state, action) => {
        const { searchId, data } = action.payload;
        state.resultsById[searchId] = data;
        state.resultStatus[searchId] = "succeeded";
        state.error = null;
      })
      .addCase(fetchFlightResults.rejected, (state, action) => {
        state.resultStatus[action.meta.arg.searchId] = "failed";
        state.error = JSON.stringify(action.payload);
      })
      .addCase(fetchFareRules.pending, (state, action) => {
        state.fareRulesStatus = "loading";
      })
      .addCase(fetchFareRules.fulfilled, (state, action) => {
        state.fareRules = action.payload.data?.resultSet || {};
        state.fareRulesStatus = "succeeded";
      })
      .addCase(fetchFareRules.rejected, (state, action) => {
        state.fareRulesStatus = "failed";
      })
      .addCase(fetchgroupfare.pending, (state, action) => {
        state.GroupFareStatus = "loading";
      })
      .addCase(fetchgroupfare.fulfilled, (state, action) => {
        state.GroupFareData = action.payload || {};
        state.GroupFareStatus = "succeeded";
      })
      .addCase(fetchgroupfare.rejected, (state, action) => {
        state.GroupFareStatus = "failed";
      })
      .addCase(fetchValidateFare.pending, (state, action) => {
        // Mark the validation status as loading for given searchId
        state.fareValidationStatus = "loading";
      })
      .addCase(fetchValidateFare.fulfilled, (state, action) => {
        const { data } = action.payload;
        // Store the validation response
        if (data.status.success) {
          state.fareValidation = data || {};
          // Update status to succeeded
          state.fareValidationStatus = "succeeded";
        } else {
          state.fareValidation = {};
          // Update status to succeeded
          state.fareValidationStatus = "failed";
        }
      })
      .addCase(fetchValidateFare.rejected, (state, action) => {
        // Store failure state
        state.fareValidationStatus = "failed";
        state.error = JSON.stringify(action.payload);
      })
      .addCase(SavePassenger.pending, (state, action) => {
        state.saveitineraryStatus = "loading";
      })
      .addCase(SavePassenger.fulfilled, (state, action) => {
        const { data } = action.payload;
        if (data.status.success) {
          state.saveitineraryData = data || {};
          state.saveitineraryStatus = "succeeded";
        } else {
          state.saveitineraryData = data || {};
          state.saveitineraryStatus = "failed";
        }
      })
      .addCase(SavePassenger.rejected, (state, action) => {
        state.saveitineraryStatus = "failed";
        state.error = JSON.stringify(action.payload);
      }).addCase(UpdatePassengers.pending, (state, action) => {
        state.UpdatePasseStatus = "loading";
      }).addCase(UpdatePassengers.fulfilled, (state, action) => {
        const { data } = action.payload;
        if (data.status.success) {
          state.UpdatePassData = data || {};
          state.UpdatePasseStatus = "succeeded";
        } else {
          state.UpdatePassData = data || {};
          state.UpdatePasseStatus = "failed";
        }
      }).addCase(UpdatePassengers.rejected, (state, action) => {
        state.UpdatePasseStatus = "failed";
        state.error = JSON.stringify(action.payload);
      })
      .addCase(SaveGroupRequest.pending, (state, action) => {
        state.saveGroupReqStatus = "loading";
      }).addCase(SaveGroupRequest.fulfilled, (state, action) => {
        const { data } = action.payload;
        if (data.status.success) {
          state.saveGroupReqData = data || {};
          state.saveGroupReqStatus = "succeeded";
        } else {
          state.saveGroupReqData = data || {};
          state.saveGroupReqStatus = "failed";
        }
      })
      .addCase(SaveGroupRequest.rejected, (state, action) => {
        // Store failure state
        state.saveitineraryStatus = "failed";
        state.error = JSON.stringify(action.payload);
      })
      .addCase(offlineTicketQueue.pending, (state, action) => {
        state.offlineQueueStatus = "loading";
      }).addCase(offlineTicketQueue.fulfilled, (state, action) => {
        const { data } = action.payload;
        if (data.status.success) {
          state.offlineQueueData = data || {};
          state.offlineQueueStatus = "succeeded";
        } else {
          state.offlineQueueData = data || {};
          state.offlineQueueStatus = "failed";
        }
      })
      .addCase(offlineTicketQueue.rejected, (state, action) => {
        state.offlineQueueStatus = "failed";
        state.error = JSON.stringify(action.payload);
      })
      .addCase(fetchBookingDetails.pending, (state, action) => {
        state.BookingDetailsStatus = "loading";
      })
      .addCase(fetchBookingDetails.fulfilled, (state, action) => {
        const { data } = action.payload;
        if (data.status.success) {
          state.BookingDetails = data || {};
          state.BookingDetailsStatus = "succeeded";
        } else {
          state.BookingDetails = data || {};
          state.BookingDetailsStatus = "failed";
        }
      })
      .addCase(fetchBookingDetails.rejected, (state, action) => {
        state.BookingDetailsStatus = "failed";
        state.error = JSON.stringify(action.payload);
      }).addCase(fetchPassengerDetails.pending, (state, action) => {
        state.PassengerDetailsStatus = "loading";
      }).addCase(fetchPassengerDetails.fulfilled, (state, action) => {
        const { data } = action.payload;
        if (data.status.success) {
          state.PassengerDetails = data || {};
          state.PassengerDetailsStatus = "succeeded";
        } else {
          state.PassengerDetails = data || {};
          state.PassengerDetailsStatus = "failed";
        }
      }).addCase(fetchPassengerDetails.rejected, (state, action) => {
        state.PassengerDetailsStatus = "failed";
        state.error = JSON.stringify(action.payload);
      })
      .addCase(doBookingProcess.pending, (state, action) => {
        state.BookingProcessStatus = "loading";
      })
      .addCase(doBookingProcess.fulfilled, (state, action) => {
        const { data } = action.payload;
        if (data.status.success) {
          state.BookingProcess = data || {};
          state.BookingProcessStatus = "succeeded";
        } else {
          state.BookingProcess = data || {};
          state.BookingProcessStatus = "failed";
        }
      })
      .addCase(doBookingProcess.rejected, (state, action) => {
        state.BookingProcessStatus = "failed";
        state.error = JSON.stringify(action.payload);
      })
      .addCase(fetchbookingcalendar.pending, (state, action) => {
        state.bookingcalendarStatus = "loading";
      })
      .addCase(fetchbookingcalendar.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.bookingcalendarStatus = data.status.success;
        state.bookingcalendar = data || {};
      })
      .addCase(fetchbnplduereport.pending, (state, action) => {
        state.bnpldueStatus = "loading";
      })
      .addCase(fetchbnplduereport.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.bnpldueStatus = data.status.success;
        state.bnpldue = data || {};
      })
      .addCase(validatecoupons.pending, (state, action) => {
        state.validatecoupStatus = "loading";
      })
      .addCase(validatecoupons.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.validatecoupStatus = data.status.success;
        state.validatecoup = data || {};
      }).addCase(GroupRequestUpdate.pending, (state, action) => {
        state.RequestStatus = "loading";
      }).addCase(GroupRequestUpdate.fulfilled, (state, action) => {
        const { data } = action.payload;
        if (data.status.success) {
          state.RequestData = data || {};
          state.RequestStatus = "succeeded";
        } else {
          state.RequestData = data || {};
          state.RequestStatus = "failed";
        }
      }).addCase(GroupRequestUpdate.rejected, (state, action) => {
        // Store failure state
        state.RequestStatus = "failed";
        state.error = JSON.stringify(action.payload);
      });
    // .addCase(fetchFlightResultsNew.pending, (state, action) => {
    //   state.SearchResponseStatus = 'loading';
    // }).addCase(fetchFlightResultsNew.fulfilled, (state, action) => {
    //   const { searchId, index, searchIDS, data } = action.payload;
    //   state.Searchindex = index;
    //   state.SearchsearchIDS = searchIDS;
    //   state.SearchResponseStatus = data.status.success;
    //   state.SearchResponse = data || {};
    // }).addCase(fetchFlightResultsNew.rejected, (state, action) => {
    //   state.SearchResponseStatus = 'failed';
    //   state.SearchResponse = {};
    //   state.error = JSON.stringify(action.payload);
    // })
  },
});

export const {
  resetFareValidation,
  resetSaveItinerary,
  resetBookingDetails,
  resetFlightData,
  setFlightsAndFilters,
  setFlightsAndFiltersNew,
  updateAirlineFilter,
  updateStopFilter,
  updatePriceRange,
  updateDepartureTimeFilter,
  clearAllFilters,
} = flightsSlice.actions;

export const selectFlightData = (state) => state.flights.data;
export const selectFlightResults = (state) => state.flights.resultsById;
export const selectFlightStatus = (state) => state.flights.status;
export const selectResultStatus = (state) => state.flights.resultStatus;
export const selectInterNationalSearch = (state) => state.flights.interNationalSearch;
export const selectRouteType = (state) => state.flights.routeType;
export const selectFareValidation = (state) => state.flights.fareValidation;
export const selectFareValidationStatus = (state) => state.flights.fareValidationStatus;
export const selectsaveitineraryData = (state) => state.flights.saveitineraryData;
export const selectsaveitineraryStatus = (state) => state.flights.saveitineraryStatus;
export const selectBookingDetails = (state) => state.flights.BookingDetails;
export const selectBookingDetailsStatus = (state) => state.flights.BookingDetailsStatus;

export const selectPassengerDetails = (state) => state.flights.PassengerDetails;
export const selectPassengerDetailsStatus = (state) => state.flights.PassengerDetailsStatus;

export const selectGroupFareData = (state) => state.flights.GroupFareData;
export const selectGroupFareStatus = (state) => state.flights.GroupFareStatus;

export default flightsSlice.reducer;
